// extracted by mini-css-extract-plugin
export var aircallIframe = "_df-3";
export var fabContainer = "_df-5";
export var fabRinging = "_df-6";
export var loadingOverlay = "_df-4";
export var pulse = "_df-7";
export var widgetContent = "_df-2";
export var widgetPanel = "_df-0";
export var widgetPanelExpanded = "_df-1";